// extracted by mini-css-extract-plugin
export default {"home":"Home_home__TSYx6","content":"Home_content__q2luQ","search_form":"Home_search_form__GAH7J","noposts":"Home_noposts__qh7aY","post_list":"Home_post_list__QPFOJ"};